import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import {useTranslations} from "use-intl";

import { CategoryShort } from '@/typings/model';
import DropDown from '@/components/DropDown';
import TextWithIcon from '@/modules/Blog/components/Top/components/TextWithIcon';
import Link from '@/components/Link';
import { colors } from '@/constants/theme';
import {
  convertActivePath,
  getCurrentAliasPage,
} from '@/modules/Blog/components/Top/components/helpers';

type Props = {
  categories: Array<CategoryShort>;
  className?: string;
  title: string;
};

const BlogNavigation = ({ categories, className, title }: Props) => {
  const router = useRouter();
  const stringifiedPath = getCurrentAliasPage(router.asPath);
  const tabToHighlight = convertActivePath(stringifiedPath);
  const t = useTranslations();

  const filteredCategories = useMemo(() => {
    const categoriesWithGlossary: CategoryShort[] = [];
    if (categories.length > 0) {
      categoriesWithGlossary.unshift(
        {
          id: 0,
          language: null,
          name: t('blog.slovar'),
          urlAlias: 'slovar',
        },
        ...categories
      );
      return categoriesWithGlossary;
    }
    return [];
  }, [categories]);
  return (
    <Component className={className}>
      <DropDown
        title={title}
        className="dropdown-component"
        activeTab={tabToHighlight}
      >
        <List>
          {filteredCategories.map((category) => (
            <Link
              key={category.id}
              to={
                category.name === t('blog.slovar')
                  ? '/blog/slovar'
                  : '/blog/category/' + category.urlAlias
              }
            >
              <ListItem>
                <TextWithIcon
                  text={category.name}
                  withIcon={category.name === t('blog.slovar')}
                  className={`text-element_${
                    tabToHighlight === category.urlAlias
                      ? 'highlighted'
                      : 'hide'
                  }`}
                />
              </ListItem>
            </Link>
          ))}
        </List>
      </DropDown>
    </Component>
  );
};

export default BlogNavigation;

const Component = styled.div`
  position: relative;
  &:before,
  &:after {
    position: absolute;
    content: '';
    border-top: 1px solid ${colors.grayLighter};
    width: 100vw;
    margin-left: calc(50% - 50vw);
    margin-right: calc(50% - 50vw);
  }
  .dropdown-component {
    padding: 5px 0;
  }
`;

const List = styled.ul``;
const ListItem = styled.li``;
